<template>
  <div v-if="blok.Carousel" v-editable="blok" :class="marginClasses">
    <BasicSlider
      v-if="blok.ImageText && blok.ImageText.length"
      :items="blok.ImageText"
      :scale-slides-to-track-width="true"
      key-prop="_uid"
      @slide-visible="handleVisibility"
    >
      <template #item="{ item: imageText, index }">
        <ImageText
          :key="imageText._uid"
          class="px-[2.5px]"
          :blok="imageText"
          :index="String(index)"
          :tracking-action="
            () => {
              trackPromotionSelect({
                id: imageText.promotion_id || 'image_text_grid_promotion_id',
                name:
                  imageText.promotion_name || 'image_text_grid_promotion_name',
                promoType: 'imagetextgrid',
                position: index + 1,
                creativeNameSb: blok.creative_name || '',
              })
            }
          "
          :optimise-desktop="blok.ImageText.length > 1"
        />
      </template>
    </BasicSlider>
  </div>
  <div
    v-else
    v-editable="blok"
    class="grid grid-cols-1 gap-[24px] md:grid-cols-2 md:gap-[5px] lg:flex"
    :class="[marginClasses]"
  >
    <ImageText
      v-for="(imageText, index) in blok.ImageText"
      :key="imageText._uid"
      :blok="imageText"
      class="col-span-1 min-w-0"
      :optimise-desktop="(blok.ImageText || []).length > 1"
      :index="String(index)"
    />
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import useStoryblokMargins from '~/cms/storyblok/composables/useStoryblokMargins'
import useTrackingEvents from '~/composables/tracking/useTrackingEvents'
import type {
  SbImageText,
  SbImageTextGrid,
} from '~/cms/storyblok/types/storyblok.d.ts'

const props = defineProps({
  blok: {
    type: Object as PropType<SbImageTextGrid>,
    default: () => {},
  },
})

const { trackPromotionSelect, trackPromotionView } = useTrackingEvents()
const { marginClasses } = useStoryblokMargins(props.blok)

const trackingCollector = ref<SbImageText[]>([])

const handleVisibility = (visibleItems: SbImageText[], index: number) => {
  const untrackedItems = visibleItems?.filter(
    (item) => !trackingCollector.value.includes(item),
  )

  if (untrackedItems.length === 0) {
    return
  }

  for (const [itemIndex, item] of untrackedItems.entries()) {
    trackPromotionView({
      id: item.promotion_id || 'image_text_grid_promotion_id',
      name: item.promotion_name || 'image_text_grid_promotion_name',
      promoType: 'imagetextgrid',
      position: index + 1 + itemIndex,
      creativeNameSb: props.blok.creative_name || '',
    })
  }

  trackingCollector.value.push(...untrackedItems)
}
</script>
